import React, { Fragment } from 'react';
import { FormButtonContainer } from '../style';
import { SemiTransparentButton, OuterIndent } from '../../../Layouts';
import { Link } from 'react-router-dom';
import { paths } from '../../../../Constants/paths';
import FacebookAuth from '../FacebookAuth';

export const SignInButtons = () => (
    <Fragment>
        <FormButtonContainer>
            <FacebookAuth />
        </FormButtonContainer>
        <OuterIndent indent={'8px 0'} />
        <FormButtonContainer>
            <Link to={paths.SIGN_IN}>
                <SemiTransparentButton>Sign in with email</SemiTransparentButton>
            </Link>
        </FormButtonContainer>
    </Fragment>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/Authentication/SignIn/SignInButtons.js